import { render, staticRenderFns } from "./bibliometric_analysis.vue?vue&type=template&id=254c5f57&scoped=true"
import script from "./bibliometric_analysis.vue?vue&type=script&lang=js"
export * from "./bibliometric_analysis.vue?vue&type=script&lang=js"
import style0 from "./bibliometric_analysis.vue?vue&type=style&index=0&id=254c5f57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c5f57",
  null
  
)

export default component.exports